import { STORY_STOPS } from "../../hooks/home-story-layout";
import type { HomeStoryShowcase } from "../../hooks/home-story-showcase";

export type HomeStoryChapterId = "model" | "material" | "finish" | "asset" | "board";

export type HomeStoryChapter = {
  id: HomeStoryChapterId;
  number: string;
  title: string;
  body: string;
  /** 章节在置顶区段里的停靠进度，与 3D 场景共用 STORY_STOPS。 */
  stop: number;
};

/** 与编辑器里真实的创作顺序一致，所以用序号表达。 */
export const homeStoryChapters: HomeStoryChapter[] = [
  {
    id: "model",
    number: "1",
    title: "定模型",
    body: "从素材库挑一个模型，或上传自己的 3D 文件，摆上底板。形体先定下来，后面每一步才有落点。",
    stop: STORY_STOPS[1],
  },
  {
    id: "material",
    number: "2",
    title: "材质",
    body: "水磨石、胡桃木、洞石、镜面铬。从材质库挑选，一键赋到模型表面，纹理和颜色实时可见。",
    stop: STORY_STOPS[2],
  },
  {
    id: "finish",
    number: "3",
    title: "工艺",
    body: "同一个形体，换一道工艺就是另一种触感。拉丝、长虹玻璃、镜面、釉面，光一扫过就能看出差别。",
    stop: STORY_STOPS[3],
  },
  {
    id: "asset",
    number: "4",
    title: "素材",
    body: "把参考图、配件和道具放进场景。主体有了陪衬，构图一下子就完整了。",
    stop: STORY_STOPS[4],
  },
  {
    id: "board",
    number: "5",
    title: "合成情绪板",
    body: "调好光影，一键渲染，得到一张可以直接分享、也能继续编辑的情绪板。",
    stop: STORY_STOPS[5],
  },
];

/** 材质章节换成后台材质后，说明文字同步列出它们的名字。 */
export function chapterBody(chapter: HomeStoryChapter, showcase: HomeStoryShowcase | null) {
  if (chapter.id !== "material" || !showcase?.materials.length) return chapter.body;
  const names = showcase.materials.map((item) => item.name).join("、");
  return `${names}，都来自 MoodShow 材质库。挑一种，一键赋到模型表面，颜色和质感实时可见。`;
}
